module.exports = __webpack_public_path__ + "static/gray_render-b5070b30dd30e2fa7549b80c5a109cbb.png";